import { FixtureMapping } from './mappings/fixtureMapping';

export function convertTime(time) {
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  
    if (time.length > 1) { 
      time = time.slice(1); 
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; 
      time[0] = +time[0] % 12 || 12; 
    }
    return time.join(''); 
}

export function convertName(fullName) {
    const nameParts = fullName?.split(' ');
    if (nameParts?.length > 1) {
        return `${nameParts[0]} ${nameParts[1][0]}`;
    }
    return fullName; // Return the original name if it doesn't have a space
}

export function getTransformedFixture(response) {
    const transformedFixture = transformResponseToFixtureMap(response, FixtureMapping);
    return transformedFixture;
}

function transformResponseToFixtureMap(initialData =[], keyMappings) {
    const transformedFixtureData = []
    try {
        initialData.map((data) => {
          let transformedFixtureMap = {};
          for (const key in data) {
            if (keyMappings.hasOwnProperty(key)) {
                transformedFixtureMap[keyMappings[key]] = data[key];
            } else {
                transformedFixtureMap[key] = data[key];
            }
          }
          transformedFixtureData.push(transformedFixtureMap)
        })
      transformedFixtureData.sort((a, b) => a.matchDate - b.matchDate);
    } catch (error) {
      console.log("No data from tour API")
    }
    
    return transformedFixtureData;
}  

export function createDOMElement(dom) {
    const { innerHTML, attributes, ele, styles, event, innerText, parent } = dom;
    const element = document.createElement(ele);
    if (attributes) {
      Object.keys(attributes).forEach(function (key) {
        element.setAttribute(key, attributes[key]);
      });
    }
    if (styles) {
      Object.keys(styles).forEach(function (key) {
        element.style[key] = styles[key];
      });
    }
    if (innerHTML) {
      element.innerHTML = innerHTML;
    }
    if (innerText) {
      element.innerHTML = innerText;
    }
    if (event && !event.isDisabled) {
      element.addEventListener(event.type, event.listener, event.capturing);
    }
    parent && parent.appendChild(element);
    return element;
  }